import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';

import {
    Badge,
    Avatar,
    colors
} from '@material-ui/core';

import {
    AvatarSkeleton,
    ContainedIconButton
} from '../common';


import CloseIcon from '@material-ui/icons/Close';
import ImageIcon from '@material-ui/icons/Image';

import { useTheme } from '@material-ui/core/styles';
import { makeStyles, withStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        marginTop: 8,
        overflowX: "auto",
        flexWrap: "nowrap",
        backgroundColor: colors.grey[300],
        minHeight: 114
    },
    avatarSkeleton: {
        borderRadius: "50%",
        backgroundColor: "#CCCCCC",
        boxShadow: "rgb(0 0 0 / 30%) 0px 0px 5px 0px inset",
    },
}));

export const ImageRowList = ({
    size,
    images,
    imagePropName,
    removeImageHandler,
    ...props }) => {
    const classes = useStyles();
    const theme = useTheme();

    return (
        <div className={clsx(classes.root, props.className, "mnu-itms-list")}>
            {images.map((x, index) =>
                <div key={index} style={{ marginLeft: 4, marginRight: 4, margin: theme.spacing(1), }}>
                    <Badge
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        overlap="circle"
                        badgeContent={
                            removeImageHandler &&
                            <ContainedIconButton
                                style={{ backgroundColor: "#FF2B56" }}
                                size="small"
                                onClick={() => removeImageHandler(x)}>
                                <CloseIcon style={{ color: "#FFF" }} />
                            </ContainedIconButton>}>
                        <AvatarSkeleton
                            width={size}
                            height={size}
                            src={imagePropName ? x[imagePropName] : x}
                            variant="circle"
                            className={classes.avatarSkeleton}
                            style={{ width: size, height: size }}
                        >
                            <Avatar
                                style={{ width: size, height: size }}>
                                <ImageIcon />
                            </Avatar>
                        </AvatarSkeleton>
                    </Badge>
                </div>)}
        </div>
    )
}